import React, { Component } from 'react';

class NotFound extends Component {
  render() {
    return (
      <div>
        <h1> 404 - Not found ¯\_(ツ)_/¯ </h1>
      </div>
    );
  }
}

export default NotFound;
